import { colours } from '../../_styleguide/_colours';
import { slugify } from '../../utils/slugify.utils';
var colourArray = ['moss', 'orange', 'blue', 'purple', 'green', 'yellow', 'orange'];
var ChartStackedBarsNormalized = /** @class */ (function () {
    function ChartStackedBarsNormalized(ctrlr) {
        this.ctrlr = ctrlr;
    }
    ChartStackedBarsNormalized.prototype.draw = function (data) {
        this.series = this.ctrlr.svg.layers.data.selectAll(".stackGroup")
            .data(data.stacked)
            .join("g");
        this.barGroup = this.series
            .selectAll("g")
            .data(function (d) { return d; }) // descends one level
            .join("g");
        this.bar = this.barGroup
            .append("rect")
            .attr("class", "bar");
        this.barLabels = this.barGroup
            .append('text')
            .attr('class', 'barLabel small-label')
            .attr('x', 0)
            .attr('dx', '0px')
            .attr('dy', '-6px')
            .style("fill", "black")
            .style("text-anchor", "middle");
        this.groupLabels = this.ctrlr.svg.layers.axes.selectAll('.serieLabel')
            .data(data.grouped)
            .join('text')
            .attr('class', 'serieLabel')
            .attr('x', 0)
            .attr('dx', this.ctrlr.config.padding.left)
            .attr('dy', '2px')
            .style("text-anchor", "start")
            .style("font-size", ".825rem")
            .attr('fill-opacity', 1);
    };
    ChartStackedBarsNormalized.prototype.redraw = function () {
        var _this = this;
        var xOffset;
        var self = this;
        this.series
            .attr("class", function (d, i) { return "stackGroup " + slugify(d.key); })
            .attr('stroke', function (d, i) { return colours[colourArray[i]][0]; })
            .attr('fill', function (d, i) { return colours[colourArray[i]][1]; })
            .attr("transform", "translate(0," + (self.ctrlr.config.padding.top) + ")");
        this.bar
            .attr("height", self.ctrlr.scales.y.scale.bandwidth())
            .attr("y", function (d) { return _this.ctrlr.scales.y.fn(d.data['label']); })
            // .transition()
            // .duration(200)
            .attr("x", function (d) { return _this.ctrlr.scales.x.fn(d[0]); })
            .attr("width", function (d) { return _this.ctrlr.scales.x.fn(d[1]) - _this.ctrlr.scales.x.fn(d[0]) - 5; });
        this.barLabels
            .text(function (d, i, e) {
            for (var _i = 0, _a = Object.keys(d.data); _i < _a.length; _i++) {
                var key = _a[_i];
                if (e[i].parentNode.parentNode.classList.contains(slugify(key))) {
                    return d.data[key];
                }
            }
        })
            .attr('transform', function (d) {
            xOffset = ((_this.ctrlr.scales.x.fn(d[0]) - _this.ctrlr.scales.x.fn(d[1])) / 2);
            return 'translate(' + (_this.ctrlr.scales.x.fn(d[0]) - xOffset) + ',' + ((_this.ctrlr.scales.y.fn(d.data['label']) + (_this.ctrlr.scales.y.scale.bandwidth() / 2)) + 11) + ')';
        })
            .attr('fill-opacity', 0)
            .attr('stroke', function (d, i) { return "transparent"; })
            .attr('fill', function (d, i) { return "black"; })
            .transition()
            .delay(500)
            .duration(500)
            .attr('fill-opacity', 1);
        this.groupLabels
            .text(function (d, i) { return (d.label === 'outflow') ? 'Aantal dossiers dat afgelopen week een stap in procedure heeft gemaakt' : d.label; })
            .attr('transform', function (d, i) { return 'translate(' + self.ctrlr.config.margin.left + ',' + (self.ctrlr.scales.y.fn(d.label) - 10) + ')'; });
    };
    return ChartStackedBarsNormalized;
}());
export { ChartStackedBarsNormalized };
